import React from 'react';
import { Provider } from 'react-redux';

import store from '@railHightlight/store';
import App from '@railHightlight/components/App';

const RailHightlightApp = ({ railType, railTitle, railCategory }) => (
  <Provider store={store}>
    <App
      railType={railType}
      railTitle={railTitle}
      railCategory={railCategory}
    />
  </Provider>
);

export default RailHightlightApp;
